import type { CID } from "multiformats";

import type { HeliaNode, ProgressCallback, AddFileResult } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";

export abstract class HeliaService {
  abstract createNode(libp2p: LibP2pWithServices): Promise<HeliaNode>;
  abstract destroyNode(node: HeliaNode): Promise<void>;
  abstract addFile(node: HeliaNode, file: File, onProgress?: ProgressCallback): Promise<AddFileResult>;
  abstract getFile(node: HeliaNode, cid: CID, onProgress?: ProgressCallback): Promise<Uint8Array>;
  abstract fileExists(node: HeliaNode, cid: CID): Promise<boolean>;
  abstract pinFile(node: HeliaNode, cid: string | CID): Promise<void>;
  abstract unpinFile(node: HeliaNode, cid: string | CID): Promise<void>;
  abstract isPinned(node: HeliaNode, cid: string | CID): Promise<boolean>;
}

